<template>
    <div v-show="show" class="common-popup-bg">
        <div class="common-popup">
            <h3>创建账号</h3>
            <el-form ref="ruleForm" class="form" :model="form" :rules="rules" size="medium">
                <el-form-item label="用户账号：" prop="username">
                    <el-input v-model="form.username" placeholder="6-16位英文或数字"/>
                </el-form-item>
                <el-form-item label="俱乐部ID：" prop="clubRandomId">
                    <el-input v-model="form.clubRandomId" placeholder="请输入">
                        <el-switch v-model="form.tribeOwner" slot="append" active-text="联盟主号"></el-switch>
                    </el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="form.remark" placeholder="请输入"/>

                </el-form-item>
                <el-form-item label="手机号：" prop="contact">
                    <div class="mobile">
                        <el-input v-model="form.mobileAreaCode" placeholder="区号"/>
                        <el-input v-model="form.mobileNo" placeholder="手机号"/>
                    </div>
                </el-form-item>
                <el-form-item label="密码：" prop="password">
                    <el-input v-model="form.password" type="password"
                              placeholder="6-16位英文或数字或者“!@#$%^&*.”"/>
                </el-form-item>
                <el-form-item label="密码确认：" prop="repeatPassword">
                    <el-input v-model="form.repeatPassword" type="password" placeholder="请输入"/>
                </el-form-item>
            </el-form>
            <footer>
                <el-button size="small" @click="close('ruleForm')">取消</el-button>
                <el-button size="small" type="primary" @click="submitForm('ruleForm')">创建</el-button>
            </footer>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show: false,
                form: {
                    username: '',
                    clubRandomId: '',
                    tribeOwner: false,
                    remark: '',
                    mobileAreaCode: '',
                    mobileNo: '',
                    password: '',
                    repeatPassword: ''
                },
                rules: {
                    username: [
                        {required: true, message: '请输入用户账号', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                if (!/^[A-Za-z0-9]{6,16}$/.test(value)) {
                                    callback(new Error('6-16位英文或数字'));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                if (!/^[A-Za-z0-9!@#$%^&*.]{6,16}$/.test(value)) {
                                    callback(new Error('6-16位英文或数字或者“!@#$%^&*.”'));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    repeatPassword: [
                        {required: true, message: '请输入密码确认', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                if (value !== this.form.password) {
                                    callback(new Error('两次输入密码不一致!'));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'
                        }
                    ],
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = Object.assign({}, this.form, {
                            password: window.btoa(this.form.password),
                            repeatPassword: window.btoa(this.form.repeatPassword)
                        });
                        this.$emit('my-submit', {
                            value: params, cb: () => {
                                this.close(formName)
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .form {
        padding-top: 20px;
        :global(.el-input) {
            width: 280px;
        }
        .mobile {
            :global(.el-input:first-of-type) {
                width: 70px;
            }
            :global(.el-input:last-of-type) {
                width: 200px;
                margin-left: 10px;
            }
        }
        :global(.el-form-item) {
            padding: 0 40px 0 30px;
        }
        :global(.el-form-item__label) {
            display: inline-block;
            width: 100px;
        }
        :global(.el-form-item__content) {
            display: inline-block;
        }
    }
</style>